import { TypographyProps } from '@mui/material';
import React from 'react';
import { LabelSmallBoldStyled, LabelSmallCustomStyled, LabelSmallStyled } from 'v3/shared/typography/LabelSmall/styles';

export const LabelSmall: React.FC<TypographyProps> = (props) => {
  return (
    <LabelSmallStyled variant="caption" {...props}>
      {props.children}
    </LabelSmallStyled>
  );
};

export const LabelSmallCustom: React.FC<TypographyProps> = (props) => {
  return (
    <LabelSmallCustomStyled variant="caption" {...props}>
      {props.children}
    </LabelSmallCustomStyled>
  );
};

export const LabelSmallBold: React.FC<TypographyProps> = (props) => {
  return (
    <LabelSmallBoldStyled variant="caption" {...props}>
      {props.children}
    </LabelSmallBoldStyled>
  );
};
